/**
 * Platform detection utilities.
 *
 * isIOS() decides which audio routing mode the player uses:
 * - iOS  -> never create a realtime AudioContext (CarPlay/Bluetooth glitches);
 *           FX are applied via OfflineAudioContext rendering instead.
 * - else -> realtime Web Audio graph is allowed when FX are enabled.
 */

let testOverride = null;

/**
 * Detect iOS / iPadOS.
 * Note: iPadOS 13+ reports "MacIntel" as platform but exposes touch points.
 * @returns {boolean}
 */
export function isIOS() {
  if (testOverride !== null) return testOverride;
  if (typeof navigator === 'undefined') return false;

  const ua = navigator.userAgent || '';
  const classicIOS = /iPad|iPhone|iPod/.test(ua);
  const iPadOSAsMac =
    navigator.platform === 'MacIntel' && (navigator.maxTouchPoints || 0) > 1;

  return classicIOS || iPadOSAsMac;
}

/**
 * Force isIOS() to a fixed value in unit tests.
 * Pass null to restore real detection.
 * @param {boolean|null} value
 */
export function setIOSOverrideForTesting(value) {
  testOverride = value;
}
